export default "__VITE_ASSET__DitwD0Be__"